import * as yup from "yup";

export const AcademicLevelFormValidation = yup.object().shape({
    description: yup.string()
        .required("O nome do nível acadêmico é obrigatório")
,
    code: yup.string(),
    idKnowledgeSubDomain: yup.string() ,
    idKnowledgeDomain: yup.string()   ,
    status: yup.boolean().default(true),
});
